<template>
  <v-dialog v-model="active" width="500">
    <v-card>
      <v-card-title class="d-flex flex-row justify-space-between align-center">
        Sticker
        <v-btn icon @click="active = false">
          <v-icon>{{ "close" }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4">
        <v-form ref="form" @submit.prevent="onSubmit">
          <v-select
            label="Orientation"
            :items="orientation"
            v-model="sticker.orientation"
            outlined
            dense
            item-text="name"
            item-value="value"
            :rules="rules"
          ></v-select>
          <v-file-input
            v-model="sticker.file"
            accept="image/png, image/jpeg"
            outlined
            dense
            label="Attach sticker"
            append-icon="$file"
            prepend-icon=""
            :rules="rules"
          >
          </v-file-input>
          <v-checkbox
            v-model="sticker.isPromo"
            class="mt-0"
            label="Use as promo sticker"
          ></v-checkbox>
          <v-btn type="submit" block color="primary" :loading="pending">
            Save sticker
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
class Sticker {
  constructor(orientation = "auto", isPromo = false, file = null) {
    this.orientation = orientation;
    this.isPromo = isPromo;
    this.file = file;
  }
}

export default {
  name: "StickerDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    stickerId: {
      type: String,
      default: "",
    },
    terminal: {
      type: String,
      required: true,
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.sticker = new Sticker();
      }
    },
  },
  data: () => ({
    sticker: new Sticker(),
    orientation: [
      { name: "Auto", value: "auto" },
      { name: "Vertical", value: "vertical" },
      { name: "Horizontal", value: "horizontal" },
    ],
    pending: false,
    rules: [(v) => !!v || "Field is required"],
  }),
  computed: {
    active: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    async onSubmit() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.pending = true;
        try {
          const formData = new FormData();
          Object.keys(this.sticker).forEach((key) => {
            formData.append(key, this.sticker[key]);
          });
          formData.append("terminal", this.terminal);
          await this.$http.post("rest/stickers", formData);
          this.$emit("resetData");
        } catch (err) {
          console.log(err);
        } finally {
          this.pending = false;
          this.active = false;
        }
      }
    },
  },
};
</script>
